export default __webpack_public_path__ + "static/media/dropdown.4b060006.svg";